
import React from 'react';
import {cls, Column, Grid, Row, Button} from '../../../packages/components';
import './styles/cardChannelSearch.scss';
import ProgressBar from '../../../components/ProgressBar';
import getBadges from '../../../utils/Badges';
import WrapperContentPlay from './WrapperContentPlay';
import Utils from '../../../utils/Utils';
import { Pin } from '../../../AAF/Pin/main';
import CardBlockedChannel from './CardBlockedChannel';
import UtilsSearch from '../UtilsSearch';


const createMarkup =(markup) =>{
    return { __html: markup };
}

const getLeftElement = (contentItem, percent = null, badges = null) => {
  const {channel_group = {}, id:groupId = null} = contentItem;
    const group_id = channel_group && channel_group.common ? channel_group.common.id : groupId;

    const blockedChannel = Pin.blockedChannelsList().includes(group_id)
    return (
        <div className={cls(`aaf-main-search-card-channel-main`)}>
            <div
                className={cls('aaf-main-search-card-channel-main-container')}
                id={`modal_episode_number_${contentItem.idx_temp || null}`}
                data-id={contentItem.idx_temp || null}>
                <div className="aaf-main-search-card-channel-main-image">
                    {blockedChannel && <CardBlockedChannel/>}
                    <div
                        className={cls('aaf-main-search-card-channel-main-image-div')}
                        style={{
                            backgroundImage: 'url(' + contentItem.image_small + ')',
                            backgroundPosition: `center`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            'background-color': '#2d2d2d',
                            // 'width': '219px',
                            // 'height': '123px'
                        }}>
                        {percent && <div className={cls('aaf-main-search-card-channel-main-image-div-progress-bar','aaf-main-search-progress')}>
                            <div className={cls('aaf-main-search-card-channel-main-image-div-progress-children')}>
                                <ProgressBar percent ={percent}/>
                            </div>
                        </div>}
                    </div>
                    {badges && <div className={`aaf-main-search-card-channel-main-badge-container`} dangerouslySetInnerHTML={createMarkup(badges)} />}
                </div>
            </div>
        </div>
    );
}

const getRightElement = (contentItem, changeRoute = null, getTextButtons = null) => {

    const {channel_number = null, title = null} = contentItem || {};
    const validateTextTitle = title ? title : '';
    const validateTextChannelNumber = channel_number ? `${channel_number}` : '';
    const validateSymbol = validateTextChannelNumber !== '' &&  validateTextTitle !== '' ? ` | ` : '';

    const titleText = `${validateTextChannelNumber}${validateSymbol}${validateTextTitle}`;

    return (
        <Grid className={cls('aaf-main-search-card-channel-main-right')}>
            <Row className={cls('aaf-main-search-card-channel-main-right-row')}>
                <Column lg={12} className={cls('aaf-main-search-card-channel-main-right-column','aaf-main-search-card-channel-main-right-column-title')}>
                    {UtilsSearch.cutString(titleText, 19)}
                </Column>
            </Row>
        </Grid>
    );
}


const onClick = (element, isPlay = false, changeRoute, sendPlayLive, sentToPurchase = () =>{}) =>{
    UtilsSearch.updateDataStoreSearcher({isFlowSearcherForPin: true});

    const {id = null} = element;
    if(!isPlay){
        // Si el usuario selecciona el poster de un contenido VOD sin derecho en cualquier “parte” del mismo debe abrir la vcard.
        const {id = null} = element;
        (typeof sentToPurchase === 'function') && sentToPurchase(id);
        // (typeof changeRoute === 'function') && changeRoute(id);
    }else{
        id && (typeof sendPlayLive === 'function') && sendPlayLive(id, true);
    }
}

const moreInfo = (element, changeRoute) =>{
    const {id = null} = element;
    (typeof changeRoute === 'function') && changeRoute(id);
}





const CardChannelSearch = ({onFocus = null, item = {}, bookmark=[], changeRoute = null, sendPlayLive = null, user= {}, getTextButtons = null, isPlay = false, sentToPurchase = () =>{}}) => {
    let badges = null;
    if(user){
        badges = getBadges(
        user,
        item.proveedor_code,
        item.format_types,
        item.live_enabled,
        item.id
      );
    }
    const {id= null} = item;
    let percent = false;
    const currentBookMark = bookmark.find((cu)=>cu.id === id);
    if(currentBookMark){
        const {vistime: {last : {progress = null} = {}} = {}} =  currentBookMark;
        percent = progress;
    }
    // width, isFakeCard = false, percent = null, onClick = null
    return (
        <WrapperContentPlay
            children_left = {
                getLeftElement(item, percent, badges)
            }
            children_right={
                getRightElement(item, changeRoute, getTextButtons)
            }
            onClick={() =>{onClick(item, isPlay, changeRoute, sendPlayLive, sentToPurchase)}}
            isPlay={isPlay}
            item ={item}
            onFocus = {onFocus}
        />
    );
};

export default CardChannelSearch;



// WEBPACK FOOTER //
// ./src/containers/Search/components/CardChannelSearch.jsx